import * as React from "react";
import coreSliceRenderers from "components/events/SliceRenderers";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
import { AssigneeCell, RiskScoreBadge, PriorityCell } from "security-app/components/common";
import { useGetPriorities as useAssetPriorities } from "security-app/hooks/useAssetsAPI";
import { useGetPriorities as useInvestgiationPriorities } from "security-app/hooks/useInvestigationsAPI";
const AssetSliceAdditional = ({ riskScore, priority }) => {
  const { priorities } = useAssetPriorities(true);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, priority ? /* @__PURE__ */ React.createElement(PriorityCell, { priorities, priorityValue: priority, size: "xs" }) : null, /* @__PURE__ */ React.createElement(RiskScoreBadge, { riskScore: riskScore != null ? riskScore : 0, size: "xs" }));
};
const InvestigationSliceAdditional = ({ priority }) => {
  const { priorities } = useInvestgiationPriorities(true);
  if (priority === void 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(PriorityCell, { priorities, priorityValue: priority, size: "xs" });
};
const extendStatusSlices = (slices) => {
  const countsByValue = new Map(slices.map((slice) => [String(slice.value), slice.count]));
  return Object.entries(SECURITY_EVENT_STATUSES).map(([value, title]) => {
    var _a;
    return {
      value,
      title,
      count: (_a = countsByValue.get(value)) != null ? _a : 0
    };
  });
};
const emptyValue = /* @__PURE__ */ React.createElement("i", null, "none");
const sliceRenderers = {
  ...coreSliceRenderers,
  owner: {
    render: ({ value, title, meta: { type } }) => {
      if (value === null) {
        return emptyValue;
      }
      return /* @__PURE__ */ React.createElement(AssigneeCell, { assignee: { label: title, type: type === "teams" ? "team" : "user", id: String(value) } });
    }
  },
  status: {
    extendSlices: extendStatusSlices,
    render: ({ value }) => {
      var _a;
      return /* @__PURE__ */ React.createElement("span", null, (_a = SECURITY_EVENT_STATUSES[String(value)]) != null ? _a : String(value));
    }
  },
  associated_assets: {
    render: ({ value, title }) => {
      if (value === null) {
        return emptyValue;
      }
      return title;
    },
    renderAdditional: ({ value, meta: { risk_score, priority } }) => {
      if (!value) {
        return null;
      }
      return /* @__PURE__ */ React.createElement(AssetSliceAdditional, { riskScore: risk_score, priority });
    }
  },
  associated_investigations: {
    render: ({ value, title }) => {
      if (value === null) {
        return emptyValue;
      }
      return title;
    },
    renderAdditional: ({ value, meta: { priority } }) => {
      if (!value) {
        return null;
      }
      return /* @__PURE__ */ React.createElement(InvestigationSliceAdditional, { priority });
    }
  }
};
export default sliceRenderers;
